"use client";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import AnimateHeight from "react-animate-height";
import { ChevronDownIcon } from "ui/iconsN";

type Props = {
  teaser: string;
};
export const Introduction = ({ teaser }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [minHeight, setMinHeight] = useState(0);
  const [maxHeight, setMaxHeight] = useState(1);
  const [showMore, setShowMore] = useState(false);

  const needShowMore = maxHeight > minHeight;

  useEffect(() => {
    if (ref.current) {
      setMinHeight(ref.current.offsetHeight);
      ref.current.classList.remove("line-clamp-4");
      setMaxHeight(ref.current.offsetHeight);
      ref.current.classList.add("line-clamp-4");
    }
  }, []);

  const handleShowMore = () => {
    if (showMore) {
      setShowMore(false);
      timeoutRef.current = setTimeout(() => {
        ref.current?.classList.add("line-clamp-4");
      }, 300);
    } else {
      setShowMore(true);
      ref.current?.classList.remove("line-clamp-4");
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
  };

  return (
    <div className="hidden @xl/side:block mt-2">
      <AnimateHeight
        duration={300}
        height={showMore ? maxHeight : minHeight !== 0 ? minHeight : 64}
        className="relative"
      >
        <div ref={ref} className="line-clamp-4">
          <p
            className={clsx("transition-colors text-xs", {
              "text-tx-2": !showMore && needShowMore,
              "text-tx-3": showMore || !needShowMore,
            })}
          >
            {teaser}
          </p>
        </div>
        {needShowMore && showMore === false && (
          <div className="absolute bottom-0 left-0 w-full h-full bg-linear-to-t from-white to-transparent" />
        )}
      </AnimateHeight>
      {needShowMore && (
        <div className="text-tx-2 stroke-tx-2 text-xs/[14px] font-medium flex justify-center">
          <div className="flex items-center gap-1 cursor-pointer" onClick={handleShowMore}>
            <ChevronDownIcon className={clsx({ "rotate-180": showMore })} />
            {showMore ? "Masquer" : "Voir plus"}
          </div>
        </div>
      )}
    </div>
  );
};
